import { connect } from "react-redux";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
// import 'bootstrap/dist/css/bootstrap.css'
import React, { useEffect, useState } from "react";
import DatatableComponent from "../../helpers/DatatableComponent";
import BasicMenu from "../../helpers/menu";
import FormDialog from "../../helpers/FormDialog";
import moment from "moment";
import { Badge } from "@mui/material";
import DeleteDialog from "../../helpers/DeleteDialog";
import { useHistory, useParams } from "react-router";
import AddForm from "../../helpers/AddForm";


function VmsClientManagement({ location, SetSelectedMenu, FetchDetails }) {
    const [open, setOpen] = React.useState(0);
    const [value, setValue] = React.useState({});
    const [list, setList] = React.useState([]);
    const [clients, setClients] = useState([]);
    const [id, setId] = React.useState();
    const [count, setCount] = React.useState(0);
    const [info, setInfo] = useState(null);
    const [selected, setSelected] = React.useState(location.state?.status ?? "all");
    const [deleteOpen, setDeleteOpen] = React.useState(false);

    const history = useHistory();
    const { id: vmsId } = useParams();

    useEffect(() => {
        setSelected(location.state?.status ?? "all");
    }, [location.state]);


    const loadClients = async () => {
        const resp = await FetchDetails(`/api/vms_client_account/list_clients/${vmsId}`);
        if (resp.status) {
            setClients(resp.data?.map(v => ({ label: v.name, id: v.id })));
        }
    }


    useEffect(() => {
        SetSelectedMenu({
            menu: "product",
            title: "Product Management"
        });
    }, []);

    const columns = [
        {
            name: "client.name",
            label: "Client Name",
        },
        {
            name: "name",
            label: "Name",
        },
        {
            name: "registrationDate",
            label: "Registration Date",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => moment(value).format("DD/MM/yyyy") ?? "",
            },
        },
        {
            name: "id",
            label: "Action",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (v) => <BasicMenu
                    onDelete={() => {
                        setDeleteOpen(true);
                        setId(v);
                    }} onEdit={() => {
                        setOpen(2);
                        const obj = list.find(vx => vx.id === v);
                        setId(v);
                        setValue0('name', obj.name);
                        setValue0('registrationDate', moment(obj.registrationDate).format("YYYY-MM-DD"));
                    }} />
            },
        },
    ];
    const setValue0 = (name, val) => {
        if (!name) {
            return null;
        }

        setValue(v => {
            v[name] = val;
            return { ...v };
        });
    }
    const onSuccess = () => setCount(v => v + 1);


    useEffect(() => {
        loadClients().then();
    }, [count]);


    return <div className="w-full mb-12 px-4">
        <DeleteDialog open={deleteOpen} setOpen={() => setDeleteOpen(false)} onSuccess={onSuccess} url={`/api/vms_client_account/delete/${id}`} />
        <AddForm col={6} open={open} onSuccess={onSuccess} setOpen={setOpen} url={open === 1 ? '/api/vms_client_account/create' : `/api/vms_client_account/update/${id}`} title={open === 1 ? "Create New VMS Account" : "Edit VMS Account"} mainFields={[
            {
                title: "",
                fields: [
                    {
                        name: "clientId",
                        label: "Client",
                        value: value['clientId'],
                        values: clients,
                        required: true,
                        type: 'select',
                        onAddNew: (label) => {
                            setClients(clients => [...clients, { label, id: label }]);
                            setValue0('clientId', label);
                        },
                        setValue: (val) => setValue0('clientId', val),
                    },
                    {
                        name: "name",
                        label: "Name",
                        value: value['name'],
                        required: true,
                        type: 'text',
                        setValue: (val) => setValue0('name', val),
                    },
                    {
                        name: "registrationDate",
                        label: "Registration Date",
                        type: "date",
                        value: value['registrationDate'],
                        required: true,
                        setValue: (val) => setValue0('registrationDate', val),
                    },
                    {
                        name: "vmsId",
                        label: "Id",
                        type: "hidden",
                        hidden: true,
                        value: vmsId,
                        required: true,
                    },
                ]
            }
        ]} />
        <DatatableComponent order={location.state?.order} onRowClick={(data, { rowIndex }) => {

        }} onAddNew={() => setOpen(1)} processData={(data) => {
            setList(data.data);
            setInfo(data.info);
            return data;
        }} elevation={1} columns={columns} url={`/api/vms_client_account/list/${vmsId}?status=${selected}&count=${count}`} title={`VMS Accounts ${info?.clientName ? `(${info?.clientName})` : ''}`} />
    </div>;
}

export default connect(mapStateToProps, mapDispatchToProps)(VmsClientManagement);
